<script lang="ts">
	import { HTMLText } from '@atoms';
	import Theme from '@tools/styles/Theme.svelte';

	let {
		data
	}: {
		data: {
			id: string;
			_modelApiKey: string;
			title: string;
			path: string;
			content: any[];
			preview: string;
			highlight: boolean;
			colorTheme?: string;
		};
	} = $props();

	const theme = new Theme(data.colorTheme);
	const breadcrumbs = $derived.by(() => {
		const parts = data.path.split('/');
		const filtered = parts.filter((p, i) => p !== '');
		filtered.pop();
		const mapped = filtered.map((part) => {
			return part.replaceAll('-', ' ').replace(/^\w/, (c) => c.toUpperCase());
		});

		return mapped.join(' / ');
	});
</script>

{#if data.highlight}
	<a class="highlight" href={data.path} style={theme.css}>
		<p class="text:body-alt">{breadcrumbs}</p>
		<h5 class="title text:h4">{data.title}</h5>
		<p><HTMLText text={data.preview} /></p>
		<div class="button:pill">Læs mere</div>
	</a>
{:else}
	<a class="basic" href={data.path}>
		<h5 class="title text:h4">{data.title}</h5>
		<div><HTMLText text={data.preview} /></div>
	</a>
{/if}

<style lang="scss">
	a {
		display: flex;
		flex-direction: column;
		padding: $gap5;
		gap: $gap4;
		text-decoration: none;

		@include md {
			padding: $gap5 $gap6;
		}
	}

	.highlight {
		grid-column-end: span 2;
		align-items: start;
		background-color: var(--theme-primary);
		color: var(--theme-foreground);

		div {
			margin-left: auto;
		}
	}

	.basic {
		align-items: stretch;
		background-color: $colorCardBackground;
		color: $colorCardForeground;

		&:hover h5 {
			text-decoration: underline;
		}
	}
</style>
